import { z } from 'zod'
import { required } from '@portal/pkg-hook-form'

const FMS_ACCESS_KEY_PATTERN = /^[0-9a-f-]{32,50}$/
const optionalText = (max: number) => z.string().trim().max(max)

export const OrgAdminSchema = z.object({
  orgName: z.string().trim().max(255).superRefine(required()),
  orgUniqueId: z.string().trim().max(36).superRefine(required()),
  description: z.string().max(255),
  powerUser: z.coerce.number().int().min(0),
  oauthAccessKey: optionalText(50).refine(
    (value) => value === '' || FMS_ACCESS_KEY_PATTERN.test(value),
    {
      message: 'admin-console:users.orgForm.fmsAccessKeyFormat',
    },
  ),
  integrationsEnabled: z.boolean(),
  entityTypeScopedAuthorizationEnabled: z.boolean(),
  powerBiWorkspaceId: optionalText(36),
  powerBiTenantId: optionalText(36),
  powerBiClientId: optionalText(36),
  powerBiClientSecretId: optionalText(40),
  dbtAccountId: optionalText(40),
  dbtJobId: z.string().trim(),
  dbtSecretKey: optionalText(64),
  dbtWebhookKey: optionalText(64),
})

export type OrgAdminFormValues = z.infer<typeof OrgAdminSchema>

export const orgAdminDefaults: OrgAdminFormValues = {
  orgName: '',
  orgUniqueId: '',
  description: '',
  powerUser: 0,
  oauthAccessKey: '',
  integrationsEnabled: false,
  entityTypeScopedAuthorizationEnabled: false,
  powerBiWorkspaceId: '',
  powerBiTenantId: '',
  powerBiClientId: '',
  powerBiClientSecretId: '',
  dbtAccountId: '',
  dbtJobId: '',
  dbtSecretKey: '',
  dbtWebhookKey: '',
}
